import { useEffect, useRef } from 'react';
import mitt, { Emitter, WildcardHandler, EventType } from 'mitt';
import { logger } from '../../../../utils';

const useEmitter = (): Emitter<Record<EventType, unknown>> | null => {
  const emitterRef = useRef<Emitter<Record<EventType, unknown>> | null>(mitt<Record<EventType, unknown>>());

  useEffect(() => {
    const logEvent: WildcardHandler<Record<EventType, unknown>> = (...args: unknown[]) => {
      logger.log('emitter event', ...args);
    };

    emitterRef?.current?.on('*', logEvent);

    return () => {
      emitterRef?.current?.off('*', logEvent);
    };
  }, []);

  return emitterRef.current;
};

export default useEmitter;
